import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { useQuery } from 'common/hooks/useQuery'
import { getCredentials } from 'store/ApplicationSlice/middleware/credential.action'
import { AppDispatch } from 'store'
import { setAnalyticsEventTypesThunkAction, setGlobalConfigurationThunkAction } from 'store/GlobalConfigurationSlice/middleware/GlobalConfigurationThunkActions'
import { AppLinks } from 'enviroment/AppLinks'
import { WorkflowTypes } from 'common/workflow'
import { IGetCredentialsThunkActionReturnProps } from 'store/ApplicationSlice/middleware/credential-actions-models'
import { setCurrentStepperMode } from 'store/ApplicationSlice/ApplicationSlice'
import { PAGE_STEPPER_MODES } from 'components/Navbar/pageSteps'
import { setTextContentsThunkAction } from 'store/TextContentsSlice/middleware/TextContentsThunkActions'
import { isTrastiBroker } from 'common/helpers/helpers'


/**
 * Hook obsługujący logikę wejścia do aplikacji poprzez link startowy "/start?appId="
*/
const useStartPageLogic = () => {
   const query = useQuery();
   const dispatch = useDispatch<AppDispatch>()
   const navigate = useNavigate()

   /**
    * Funkcja ustawiająca tryb steppera w aplikacji na podstawie obecnego workflowid
    * 
    * @param workflowId Workflow id z Backendu
    * @returns 
    */
   const handleSetCurrentStepperMode = (workflowId: number) => {

        if(WorkflowTypes.IsRetention(workflowId)){
            dispatch(setCurrentStepperMode(PAGE_STEPPER_MODES.RETENTION)) // Ustawiamy odpowiedni stepper dla danego workflow
        }
        else if (WorkflowTypes.isNormal(workflowId)){
            dispatch(setCurrentStepperMode(PAGE_STEPPER_MODES.DEFAULT)) // Ustawiamy odpowiedni stepper dla danego workflow
        }
        else {
            navigate(AppLinks.error)
            return
        }

        if(isTrastiBroker()){ //W przypadku brokera TRASTI zostajemy na ekranie czekadełka i czekamy na odpowiedź z HUBa, która zabierze nas na ekran wyboru produktu 
            navigate(AppLinks.waiting)
            return
        }

        navigate(AppLinks.productPage) //Zarówno w przypadku retencji jak i zwykłego procesu, kierujemy użytkownika na ekran wyboru produktu
   }

   useEffect(()=>{
       (async () => {// Inicjalizacja tekstów na stronę oraz pobieranie konfiguracji projektu. Zapis danych do state'a
            const appId = query.get("appId") as string
            const response = await (await dispatch(getCredentials({
               orderId: appId,
               isStartLink: true,
               source: query.get("source")
            }))).payload as IGetCredentialsThunkActionReturnProps

            if(!response) {
                navigate(AppLinks.error)
            }
            else {
                const setGlobalConfigurationDispatchResult = await dispatch(setGlobalConfigurationThunkAction())
                const setTextContentsDispatchResult = await dispatch(setTextContentsThunkAction())

                // Gdy nie uda się pobrać tej konfiguracji, nie przenosimy użytkownika na stronę z błędem, kontynuujemy proces, nie wysyłając części danych statystycznych do Backendu
                await dispatch(setAnalyticsEventTypesThunkAction()) 

                 // W przypadku gdy nie udało się pobrać konfiguracji z Backendu, przenosimy użytkownika na stornę z błędem
                if(setGlobalConfigurationDispatchResult.meta.requestStatus === 'rejected' && setTextContentsDispatchResult.meta.requestStatus === 'rejected') {
                    navigate(AppLinks.error)
                    return
                }

                handleSetCurrentStepperMode(response.workflowId)
            }
       })()

   // eslint-disable-next-line react-hooks/exhaustive-deps
   },[])
}

export default useStartPageLogic